/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Fs_OnlyInputs */



/**
* | output |
* | --- |
* | "FS Only" |
*
* @param {Subtitle_Export_Fs_OnlyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_fs_only = /** @type {((inputs?: Subtitle_Export_Fs_OnlyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Fs_OnlyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("FS uniquement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Nur FS")
	if (locale === "it") return /** @type {LocalizedString} */ ("Solo FS")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Только FS")
	if (locale === "es") return /** @type {LocalizedString} */ ("Solo FS")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("仅限FS")
	if (locale === "ja") return /** @type {LocalizedString} */ ("FSのみ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("केवल एफएस")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Somente FS")
	return /** @type {LocalizedString} */ ("FS Only")
});